import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
})

export class ExportDialogComponent implements OnInit, OnDestroy {

  @Output() submitData: EventEmitter<any> = new EventEmitter<any>();

  public isLoading: boolean = false;

  private destroy$: Subject<null> = new Subject<null>();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
